import { render, staticRenderFns } from "./home_desktop.vue?vue&type=template&id=3e643f38&scoped=true&"
import script from "./home_desktop.vue?vue&type=script&lang=js&"
export * from "./home_desktop.vue?vue&type=script&lang=js&"
import style0 from "./home_desktop.vue?vue&type=style&index=0&id=3e643f38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e643f38",
  null
  
)

export default component.exports